import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CombinationRule} from '../../models/combination-rule.model';

@Component({
  selector: 'app-combination-rule',
  templateUrl: './combination-rule.component.html'
})
export class CombinationRuleComponent implements OnInit {
  @Input() arrCombinationRules: CombinationRule[];
  @Input() index: number;
  @Input() arrResults: any;
  @Input() isDemoAd: boolean;
  @Input() statistic: boolean;
  @Input() isViewResult;
  @Input() checkControlPanel: any;
  @Output() combinationRules = new EventEmitter<CombinationRule[]>();
  @Output() saveRules = new EventEmitter<CombinationRule[]>();
  @Output() getAllResult = new EventEmitter();

  constructor() { }

  ngOnInit() {
    if (this.checkControlPanel != null) {
      this.statistic = true;
    }
  }

  addCombinationRule() {
      this.arrCombinationRules.push(<CombinationRule>{});
  }

  removeThisRule(idx: number) {
    if (this.arrCombinationRules.length > 1) {
        this.arrCombinationRules.splice(idx, 1);
    } else {
        this.arrCombinationRules.splice(idx, 1, <CombinationRule>{});
        this.arrResults = [];
    }
    this.combinationRules.emit(this.arrCombinationRules);
  }

  calculateResultsRules() {
      this.combinationRules.emit(this.arrCombinationRules);
      this.getAllResult.emit();
  }

  _saveControlPanelSettings() {
      this.saveRules.emit(this.arrCombinationRules);
  }

}
